(function(){
  window.MENEA_REVEAL = true;
  var root = document.documentElement;
  if (!root.classList.contains('js-reveal') || !('IntersectionObserver' in window)) { root.classList.remove('js-reveal'); return; }
  var SEL = '.hero-txt,.hero .placeholder,.hero .hero-img,.trust>div,.cats .sec-head,.cat,.tabs .sec-head,.tab-list,.prod,.types>.h2,.chip,.test-banner,.discreet>.h2,.step,.reviews>.h2,.rev,.faq-side,.faq-list>details,.blog .sec-head,.post,.news>div,.news>form,.about>div,.f-top,.page-title,.pdp-media,.pdp-info,.reco .sec-head,.cart-line,.summary,.empty,.coll-head,.page-wrap>.rte';
  function done(el){ el.classList.add('revealed'); el.classList.remove('is-in'); el.style.removeProperty('--d'); }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (!e.isIntersecting) return;
      var el = e.target;
      io.unobserve(el);
      el.classList.add('is-in');
      var d = parseInt(el.style.getPropertyValue('--d')) || 0;
      setTimeout(function(){ done(el); }, 800 + d);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  function init(scope){
    var s = scope || document;
    var list = Array.prototype.slice.call(s.querySelectorAll(SEL));
    if (s.matches && s.matches(SEL)) list.unshift(s);
    list.forEach(function(el){
      if (el.dataset.rv) return;
      el.dataset.rv = '1';
      var i = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.setProperty('--d', Math.min(i, 6) * 90 + 'ms');
      io.observe(el);
    });
  }
  window.meneaRevealInit = init;
  init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
